import React from "react";
import Header from "../../component/header/header";
import Footer from "../../component/footer/footer";

import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";

import "./flow.css";

// animation presets
const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0 },
};

const zoomIn = {
  hidden: { scale: 0.8, opacity: 0 },
  show: { scale: 1, opacity: 1 },
};

const Flow = () => {
  return (
    <div>
      <Header />

      <div className="flow-wrapper">
        {/* ---------- HERO WITH IMAGE ---------- */}
        <section className="flow-hero">
          <Container>
            <Row className="align-items-center">
              <Col md={6}>
                <motion.h1
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="show"
                  transition={{ duration: 0.6 }}
                  className="hero-title"
                >
                  Accelerate Your Startup Deal Flow
                </motion.h1>

                <motion.p
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="show"
                  transition={{ duration: 0.8 }}
                  className="hero-subtitle"
                >
                  A powerful pipeline for founders to secure funding, build
                  connections, and scale their business.
                </motion.p>

                {/* <motion.div
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="show"
                >
                  <button className="hero-btn">Submit Pitch</button>
                  <button className="hero-btn-outline ms-3">Explore Deals</button>
                </motion.div> */}
              </Col>

              {/* Hero image */}
              <Col md={6} className="text-center mt-5 mt-md-0">
                <motion.img
                  src="./images/in-1.jpg"
                  alt="deal flow"
                  className="hero-image"
                  variants={zoomIn}
                  initial="hidden"
                  whileInView="show"
                  transition={{ duration: 0.8 }}
                />
              </Col>
            </Row>
          </Container>
        </section>

        {/* ---------- DEAL PROCESS WITH ICONS ---------- */}
        <section className="flow-process mt-5">
          <Container>
            <h2 className="section-title mb-5">Our Deal Flow Process</h2>

            <Row className="gy-4 mb-5">
              {[
                ["discovery.png", "Startup Discovery"],
                ["screening.png", "Initial Screening"],
                ["evaluation.png", "Business Evaluation"],
                ["due.png", "Due Diligence"],
                ["negotiation.png", "Negotiation"],
                ["final.png", "Final Selection"],
              ].map(([img, step], i) => (
                <Col md={4} sm={6} key={i}>
                  <motion.div
                    className="process-box"
                    variants={zoomIn}
                    initial="hidden"
                    whileInView="show"
                    transition={{ delay: i * 0.15 }}
                  >
                    <img
                      src={"./images/in-1.jpg"}
                      alt={step}
                      className="process-icon"
                    />
                    <h4>{step}</h4>
                    <p>
                      We analyze, validate and filter startups to ensure only
                      high-quality opportunities reach investors.
                    </p>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* ---------- PITCH SECTION WITH BACKGROUND IMAGE ---------- */}
        <section className="flow-pitch">
          <div className="pitch-overlay"></div>
          <Container>
            <motion.h2
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              className="section-title text-white"
            >
              Ready to Pitch Your Startup?
            </motion.h2>

            {/* <motion.p
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              className="pitch-text"
            >
              Submit your deck and get discovered by investors actively looking
              for high-growth opportunities.
            </motion.p> */}

            {/* <motion.button
              variants={zoomIn}
              initial="hidden"
              whileInView="show"
              className="pitch-btn"
            >
              Upload Pitch Deck
            </motion.button> */}
          </Container>
        </section>

        {/* -------- DEAL EVALUATION METRICS -------- */}
        <section className="metrics-section">
          <Container>
            <h2 className="section-title">Deal Evaluation Metrics We Use</h2>

            <Row className="gy-4">
              {[
                "Market Size & Scalability",
                "Founder Strength Score",
                "Revenue Model Efficiency",
                "Traction & Unit Economics",
                "Technology Robustness",
                "Risk & Competition Index",
              ].map((metric, i) => (
                <Col md={4} key={i}>
                  <motion.div
                    className="metric-box"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.4 }}
                  >
                    {metric}
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* -------- STARTUP CHECKLIST -------- */}
        <section className="startup-checklist">
          <Container>
            <h2 className="section-title">Startup Readiness Checklist</h2>

            <ul className="checklist">
              <li>✔ Validated Business Idea</li>
              <li>✔ Clear Revenue Model</li>
              <li>✔ MVP / Prototype Ready</li>
              <li>✔ Market Research Completed</li>
              <li>✔ Financial Projection Prepared</li>
              <li>✔ Pitch Deck & Documents Ready</li>
            </ul>
          </Container>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Flow;
